var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.775,
    height: 26.775,
    viewBox: "0 0 26.775 26.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "usuario",
    d: "M13.388,0A13.388,13.388,0,1,0,26.775,13.388,13.4,13.4,0,0,0,13.388,0Zm0,25.52A12.1,12.1,0,0,1,4.559,21.7a9.162,9.162,0,0,1,17.656,0A12.1,12.1,0,0,1,13.388,25.52Zm9.778-4.959a10.4,10.4,0,0,0-6.835-6.4,5.651,5.651,0,1,0-5.886,0,10.4,10.4,0,0,0-6.835,6.4,12.133,12.133,0,1,1,19.556,0Zm-9.778-6.828a4.4,4.4,0,1,1,4.4-4.4A4.4,4.4,0,0,1,13.388,13.733Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.7b312809761bbd947420456218bb9f4f.svg";
export { ForwardRef as ReactComponent };